$(function() {
  function applyCounselingMethodSelection() {
    var type = $('#counseling_guide_form_counseling_method').children('option:selected').val();
    $('.counseling_form_section').show();
    $('#telephone_number_section').hide();
    $('#telephone_counseling_section').hide();
    $('#email_counseling_section').hide();
    $('#online_counseling_section').hide();
    $('#shop_counseling_section').hide();
    $('#confirm-btn').show();
    switch (type) {
      case 'email':
        $('#counseling-form-message').html('回答をもとに、5営業日（平日のみ）以内にメールにてご連絡させていただきます。');
        $('#partner_label').html('相談するパートナー<span class="required">（必須）</span>');
        $('#weight_label').html('体重<span class="required">（必須）</span>');
        $('#figure_label').html('体型<span class="required">（必須）</span>');
        $('#counseling_avoided_food_ids_label').html('アレルギーについて<span class="required">（必須）</span>');
        $('#counseling_avoided_food_detail_ids_label').html('アレルギーについて詳細（任意）');
        $('#veterinarian_advice_detail_label').html('獣医師から食事の指導を受けていれば教えて下さい（任意）');
        $('#staple_food_label').html('主食として与えているフードについて教えてください。<span class="required">（必須）</span>');
        $('#food_selection_request_label').html('主食以外に与えているものがあれば教えてください。（任意）');
        $('#staple_food_frequency_label').html('1日の食事の回数を教えてください。<span class="required">（必須）</span>');
        $('#worries_label').html('ご相談内容をお聞かせください<span class="required">（必須）</span>');
        $('#other_request_label').html('ペットフーディストに伝えておきたいことがございましたらお知らせください。（任意）');
        $('#movement_quantity_label').html('運動量（任意）');
        $('#fixed_label').html('避妊去勢手術の有無（任意）');
        $('#acquisition_source_label').html('窓口を知ったきっかけをお聞かせください。（任意）');
        $('#register-section').show();
        $('#partner-section').show();
        $('#email_counseling_section').show();
        break;
      case 'telephone':
        $('#telephone_number_section').show();
        $('#telephone_number_message').show();
        $('#counseling-form-message').html('よりスムーズにカウンセリングをご利用いただくことができます。');
        $('#partner_label').html('相談するパートナー<span class="required">（必須）</span>');
        $('#weight_label').html('体重<span class="required">（必須）</span>');
        $('#figure_label').html('体型<span class="required">（必須）</span>');
        $('#counseling_avoided_food_ids_label').html('アレルギーについて<span class="required">（必須）</span>');
        $('#counseling_avoided_food_detail_ids_label').html('アレルギーについて詳細（任意）');
        $('#veterinarian_advice_detail_label').html('獣医師から食事の指導を受けていれば教えて下さい（任意）');
        $('#staple_food_label').html('主食として与えているフードについて教えてください。<span class="required">（必須）</span>');
        $('#food_selection_request_label').html('主食以外に与えているものがあれば教えてください。（任意）');
        $('#staple_food_frequency_label').html('1日の食事の回数を教えてください。<span class="required">（必須）</span>');
        $('#worries_label').html('ご相談内容をお聞かせください<span class="required">（必須）</span>');
        $('#other_request_label').html('ペットフーディストに伝えておきたいことがございましたらお知らせください。（任意）');
        $('#movement_quantity_label').html('運動量（任意）');
        $('#fixed_label').html('避妊去勢手術の有無（任意）');
        $('#acquisition_source_label').html('窓口を知ったきっかけをお聞かせください。（任意）');
        $('#register-section').show();
        $('#partner-section').show();
        $('#telephone_counseling_section').show();
        break;
      case 'online':
        $('#telephone_number_section').show();
        $('#telephone_number_message').show();
        $('#counseling-form-message').html('よりスムーズにカウンセリングをご利用いただくことができます。');
        $('#partner_label').html('相談するパートナー<span class="required">（必須）</span>');
        $('#weight_label').html('体重<span class="required">（必須）</span>');
        $('#figure_label').html('体型<span class="required">（必須）</span>');
        $('#counseling_avoided_food_ids_label').html('アレルギーについて<span class="required">（必須）</span>');
        $('#counseling_avoided_food_detail_ids_label').html('アレルギーについて詳細（任意）');
        $('#veterinarian_advice_detail_label').html('獣医師から食事の指導を受けていれば教えて下さい（任意）');
        $('#staple_food_label').html('主食として与えているフードについて教えてください。<span class="required">（必須）</span>');
        $('#food_selection_request_label').html('主食以外に与えているものがあれば教えてください。（任意）');
        $('#staple_food_frequency_label').html('1日の食事の回数を教えてください。<span class="required">（必須）</span>');
        $('#worries_label').html('ご相談内容をお聞かせください<span class="required">（必須）</span>');
        $('#other_request_label').html('ペットフーディストに伝えておきたいことがございましたらお知らせください。（任意）');
        $('#movement_quantity_label').html('運動量（任意）');
        $('#fixed_label').html('避妊去勢手術の有無（任意）');
        $('#acquisition_source_label').html('窓口を知ったきっかけをお聞かせください。（任意）');
        $('#register-section').show();
        $('#partner-section').show();
        $('#online_counseling_section').show();
        break;
      case 'shop':
        $('#telephone_number_section').show();
        $('#telephone_number_message').show();
        $('#counseling-form-message').html('よりスムーズにカウンセリングをご利用いただくことができます。');
        $('#partner_label').html('相談するパートナー<span class="required">（必須）</span>');
        $('#weight_label').html('体重<span class="required">（必須）</span>');
        $('#figure_label').html('体型<span class="required">（必須）</span>');
        $('#counseling_avoided_food_ids_label').html('アレルギーについて<span class="required">（必須）</span>');
        $('#counseling_avoided_food_detail_ids_label').html('アレルギーについて詳細（任意）');
        $('#veterinarian_advice_detail_label').html('獣医師から食事の指導を受けていれば教えて下さい（任意）');
        $('#staple_food_label').html('主食として与えているフードについて教えてください。<span class="required">（必須）</span>');
        $('#food_selection_request_label').html('主食以外に与えているものがあれば教えてください。（任意）');
        $('#staple_food_frequency_label').html('1日の食事の回数を教えてください。<span class="required">（必須）</span>');
        $('#worries_label').html('ご相談内容をお聞かせください<span class="required">（必須）</span>');
        $('#other_request_label').html('ペットフーディストに伝えておきたいことがございましたらお知らせください。（任意）');
        $('#movement_quantity_label').html('運動量（任意）');
        $('#fixed_label').html('避妊去勢手術の有無（任意）');
        $('#acquisition_source_label').html('窓口を知ったきっかけをお聞かせください。（任意）');
        $('#register-section').show();
        $('#partner-section').show();
        $('#shop_counseling_section').show();
        break;
    }
  }
  applyCounselingMethodSelection();

  function setInputName(column, partnerCount) {
    return [
      'counseling_guide_form[partner_params][' + (partnerCount - 1) + '][' + column + ']',
      'counseling_guide_form[partner_params][' + partnerCount + '][' + column + ']'
    ];
  }

  function setInputId(column, partnerCount) {
    return [
      'counseling_guide_form_partner_params_' + (partnerCount - 1) + '_' + column,
      'counseling_guide_form_partner_params_' + partnerCount + '_' + column
    ];
  }

  function resetValue(addForm, element) {
    $(element).val('');
  }

  function updateNameAttributes(addForm, name, partnerCount) {
    let [beforeInputName, afterInputName] = setInputName(name, partnerCount);
    addForm.find('[name="' + beforeInputName + '"]').each(function(index, element) {
      $(element).attr('name', afterInputName);
    });
  }

  function updateIdAttributes(addForm, name, partnerCount, resetFlag) {
    let [beforeInputId, afterInputId] = setInputId(name, partnerCount);
    addForm.find('#' + beforeInputId).each(function(index, element) {
      $(element).attr('id', afterInputId);
      if(resetFlag) { resetValue(addForm, element) }
    });
  }

  function reviewDeleteButton() {
    let partnerCount = $('.partner_section').length;
    let deleteButton = $('#delete_partner_form');

    if(partnerCount > 1) {
      if(deleteButton.length) {
        deleteButton.text(partnerCount + '頭目を削除');
      } else {
        $('#partner_form_button').prepend('<div class="button-wrap__item"><button name="button" type="button" class="button-secondary" id="delete_partner_form">' + partnerCount + '頭目を削除</button></div>');
        deletePartnerAction();
      }
    } else {
      deleteButton.remove();
    }
  }

  $('#add_partner_form').on('click', function() {
    let lastPartnerSection = $('.partner_section:last');
    let addForm = lastPartnerSection.clone();
    let partnerCount = $('.partner_section').length;

    $.each(['name', 'name_kana', 'sex_male', 'sex_female', 'birthday_year', 'birthday_month', 'birthday_day', 'dog_kind_id', 'pet_kind_type'], function(index, name) {
      let resetFlag = !['sex_male', 'sex_female'].includes(name);
      updateIdAttributes(addForm, name, partnerCount, resetFlag);
      updateNameAttributes(addForm, name, partnerCount);
    });
    updateNameAttributes(addForm, 'sex', partnerCount);
    addForm.find('.new_partner_name').attr('data-no', partnerCount + 1);
    addForm.find('.partner_number').text(partnerCount + 1 + '頭目');
    addForm.find('input[type="radio"]:checked').prop('checked', false);
    addForm.find('select.pet_kind_type').val('');
    addForm.find('select.dog_kind_id').attr('disabled', true);
    addForm.find('select.dog_kind_id').parent().hide();

    lastPartnerSection.after(addForm);
    reviewDeleteButton();
  });

  function deletePartnerAction() {
    $('#delete_partner_form').on('click', function() {
      $('.partner_section:last').remove();
      reviewDeleteButton();
      updatePartnerSelect();
    });
  }
  deletePartnerAction();

  $('body').on('change', '.pet_kind_type', function(e) {
    let petKindType = $(this).val();
    let targetKinds = [];
    switch (petKindType) {
      case 'dog':
        targetKinds = selectDogKinds;
        break;
      case 'cat':
        targetKinds = selectCatKinds;
    }
    let $petKindDivSelect = $(this).closest('.select').next();
    $petKindDivSelect.find('option').remove();

    if (petKindType === 'other' || petKindType === '') {
      $petKindDivSelect.hide();
      $petKindDivSelect.children('select').attr('disabled', true);
    } else {
      $petKindDivSelect.show();
      $petKindDivSelect.children('select').removeAttr('disabled');
    }

    let $petKindSelect = $petKindDivSelect.children('select');
    if (targetKinds.length > 0) {
      let kindType = { 'dog': '犬種', 'cat': '猫種' }
      $(`<option style="display: none;" value>${kindType[petKindType]}を選択してください</option>`).appendTo($petKindSelect);
    }
    $.each(targetKinds, function(index, kind) {
      $(`<option value="${kind[1]}">${kind[0]}</option>`).appendTo($petKindSelect);
    })
  });

  // カウンセリング方法が変更された場合
  $('#counseling_guide_form_counseling_method').change(function(){
    $.ajax({
      type: "get",
      url: "/counseling_guide/reservation_calendar",
      data: {
        counseling_method: $('#counseling_guide_form_counseling_method').children('option:selected').val()
      },
      cache: false
    });
    applyCounselingMethodSelection();
  })

  // カレンダーの「店舗」が選択された場合
  $(document).on('change', '#counseling_guide_form_reservation_shop_id', function(){
    updateCalendar(1);
    updateTimes();
  })

  // カレンダーの「前の2週間」ボタンがクリックされた場合
  $(document).on('click', '.button-pagination__prev', function() {
    if (!$(this).hasClass('is-disabled')) {
      // 日付選択カレンダー更新
      updateCalendar(parseInt($('#page').val()) - 1);
      // 時間選択更新
      updateTimes();
    }
  });

  // カレンダーの「次の2週間」ボタンがクリックされた場合
  $(document).on('click', '.button-pagination__next', function() {
    if (!$(this).hasClass('is-disabled')) {
      // 日付選択カレンダー更新
      updateCalendar(parseInt($('#page').val()) + 1);
      // 時間選択更新
      updateTimes();
    }
  });

  // カレンダーで日付が選択された場合
  $(document).on('click', '.recommend-day__date', function() {
    if (!$(this).hasClass('is-disabled') && !$(this).hasClass('is-active')) {
      $('.recommend-day__date').removeClass('is-active');
      $(this).addClass('is-active');
      $('#counseling_guide_form_reservation_date').val($(this).data('value'))
      updateTimes();
    }
  });

  // 時間が選択された場合
  $(document).on('click', '.recommend-time__item', function() {
    if (!$(this).hasClass('is-disabled')) {
      $('.recommend-time__item').removeClass('is-active');
      $(this).addClass('is-active');
      $('#counseling_guide_form_reservation_time').val($(this).data('value'))
    }
  });

  $('#counseling_form').on('submit', function() {
    var type = $('#counseling_guide_form_counseling_method').children('option:selected').val();
    if (type == 'telephone') {
      $('#online_counseling_section').find('#counseling_guide_form_desired_date_online').prop("disabled", true);
      $('#online_counseling_section').find('#counseling_guide_form_desired_time_online').prop("disabled", true);
    } else if(type == 'online') {
      $('#telephone_counseling_section').find('#counseling_guide_form_desired_date_online').prop("disabled", true);
      $('#telephone_counseling_section').find('#counseling_guide_form_desired_time_online').prop("disabled", true);
    }
  });

  $("#confirm-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/counseling_guide/new");
    $(this).parents("form").submit();
  });

  $('.top-method-link').click(function(e) {
    e.preventDefault();
    let method = $(this).data('counseling-method');
    let shop_id = $(this).data('reservation-shop-id');
    $('#counseling_guide_form_counseling_method').val(method);
    $('#counseling_guide_form_reservation_shop_id').val(shop_id);
    $('#counseling_guide_top_form').submit();
  });

  $(document).on('change', '.new_partner_name', function() {
    updatePartnerSelect();
  });
});

function updateCalendar(page) {
  $('#counseling_guide_form_reservation_date').val('');
  $.ajax({
    type: "get",
    url: "/counseling_guide/reservation_dates",
    data: {
      counseling_method: $('#counseling_guide_form_counseling_method').children('option:selected').val(),
      reservation_shop_id: $('#counseling_guide_form_reservation_shop_id').children('option:selected').val(),
      page: page
    },
    cache: false
  });
}

function updateTimes() {
  $.ajax({
    type: "get",
    url: "/counseling_guide/reservation_times",
    data: {
      reservation_shop_id: $('#counseling_guide_form_reservation_shop_id').children('option:selected').val(),
      reservation_date: $('#counseling_guide_form_reservation_date').val()
    },
    cache: false
  });
}

function updatePartnerSelect() {
  let $selectTag = $('#counseling_guide_form_partner_id');
  $('option', $selectTag).remove();
  $(`<option value=''>選択してください</option>`).appendTo($selectTag);
  $('.new_partner_name').each(function() {
    if ($(this).val() != '') {
      $(`<option value="new_partner${$(this).data('no')}">${$(this).val()}</option>`).appendTo($selectTag);
    }
  });
}
